document.addEventListener('DOMContentLoaded', () => {
  new Swiper('#cl-swiper-gallery .swiper', {
    a11y: true,
    direction: 'horizontal',
    loop: true,
    slidesPerView: 1.15,
    centeredSlides: true,
    spaceBetween: 1,
    grabCursor: true,
    mousewheel: {
      forceToAxis: true,
      enabled: true,
    },
    autoplay: {
      delay: 3500,
      disableOnInteraction: true,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        centeredSlides: false,
      },
      1024: {
        slidesPerView: 3,
        centeredSlides: false,
      },
      1280: {
        slidesPerView: 4,
        centeredSlides: false,
        loop: false,
      },
    },
    pagination: {
      el: '#cl-swiper-gallery .swiper-pagination',
      clickable: true,
    },
  });
});
